import { render, staticRenderFns } from "./39.vue?vue&type=template&id=1f64e6d6&scoped=true&"
import script from "./39.vue?vue&type=script&lang=js&"
export * from "./39.vue?vue&type=script&lang=js&"
import style0 from "./39.vue?vue&type=style&index=0&id=1f64e6d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f64e6d6",
  null
  
)

export default component.exports